import React, { useState, useEffect } from 'react';
import { Link, Redirect, useHistory } from 'react-router-dom';
import api from '../apiClient';

import '../Login/login.css';

import verificandoApp from '../../FuncoesGerais/verificaApp';
import verificandoTokenSolicitante from '../../FuncoesGerais/VerificarTokenSolicitante';

function AlterarSenhaSolicitante() {
    const history = useHistory();
    const [senha, setSenha] = useState('');
    const [confirmar, setConfirmar] = useState('');
    const [mostrarSenha, setMostrarSenha] = useState(false);
    const [alter, setAlter] = useState('N');
    const [mensagemErro, setMensagemErro] = useState('');
    const [carregando, setCarregando] = useState(false);

    const verificar = async () => {
        const resultado = await verificandoApp('SOLICITANTE');
        if (!resultado) {
            history.push('/');
            return;
        }
        await verificandoTokenSolicitante(history);
    };

    useEffect(() => {
        verificar();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function verificaSenha() {
        if (!senha || senha.trim().length === 0) {
            setMensagemErro('A senha deve ser preenchida.');
            return false;
        }
        if (senha !== confirmar) {
            setMensagemErro('As senhas não coincidem.');
            return false;
        }
        if (senha.length < 8) {
            setMensagemErro('A senha deve conter ao menos 8 caracteres.');
            return false;
        }
        setMensagemErro('');
        return true;
    }

    function fncSair() {
        localStorage.setItem('codUsu', 0);
        localStorage.setItem('logado', 'N');
        localStorage.setItem('token', '');
        localStorage.setItem('refreshToken', '');
    }

    const updateUsuario = async (e) => {
        e.preventDefault();
        setMensagemErro('');
        if (!verificaSenha()) return;

        const usrSis = Number(localStorage.getItem('codUsu')) || 0;
        if (!usrSis) return;

        setCarregando(true);
        try {
            await api.put('/api/updateUsuario', { usrSis, senha });
            fncSair();
            setAlter('S');
        } catch (error) {
            const msg = error?.response?.data?.message || error?.response?.data?.error || 'Erro ao alterar senha. Tente novamente.';
            setMensagemErro(msg);
        } finally {
            setCarregando(false);
        }
    };

    if (alter === 'S') {
        return <Redirect to="/Solicitante" />;
    }

    const forca = senha.length === 0 ? 0 : senha.length < 8 ? 1 : (/[A-Z]/.test(senha) && /\d/.test(senha)) ? 3 : 2;
    const forcaLabel = ['', 'Fraca', 'Média', 'Forte'][forca];

    return (
        <div className="login-page">
            <section className="login-brand">
                <span className="login-orb login-orb--1" aria-hidden="true" />
                <span className="login-orb login-orb--2" aria-hidden="true" />
                <div className="login-brand-inner">
                    <Link to="/">
                        <img src="/Images/TACOMA_LOGO_NOVA.png" alt="Tacoma" className="login-logo" />
                    </Link>
                    <p className="login-tagline">Defina uma senha forte para manter a segurança do seu acesso.</p>
                    <ul className="login-features">
                        <li><i className="fas fa-shield-halved" /> Use ao menos 8 caracteres</li>
                        <li><i className="fas fa-arrow-up-9-1" /> Combine letras e números</li>
                        <li><i className="fas fa-user-lock" /> Não compartilhe sua senha</li>
                    </ul>
                </div>
            </section>
            <div className="login-form-wrap">
                <div className="login-form-card">
                    <h2><i className="fas fa-key" /> Alterar senha</h2>
                    <p className="subtitle">Informe e confirme sua nova senha (mínimo 8 caracteres).</p>
                    <form onSubmit={updateUsuario}>
                        <div className="login-field">
                            <label htmlFor="alterar-sol-nova-senha">Nova senha</label>
                            <div className="login-input-wrap">
                                <i className="fas fa-lock login-input-icon" />
                                <input
                                    id="alterar-sol-nova-senha"
                                    type={mostrarSenha ? 'text' : 'password'}
                                    value={senha}
                                    onChange={(e) => setSenha(e.target.value)}
                                    placeholder="Nova senha"
                                    autoComplete="new-password"
                                    disabled={carregando}
                                />
                                <button
                                    type="button"
                                    className="login-toggle-senha"
                                    onClick={() => setMostrarSenha((v) => !v)}
                                    aria-label={mostrarSenha ? 'Ocultar senha' : 'Mostrar senha'}
                                    tabIndex={-1}
                                >
                                    <i className={mostrarSenha ? 'fas fa-eye-slash' : 'fas fa-eye'} />
                                </button>
                            </div>
                            {forca > 0 && (
                                <div className={`login-forca login-forca--${forca}`}>
                                    <span /><span /><span />
                                    <small>{forcaLabel}</small>
                                </div>
                            )}
                        </div>
                        <div className="login-field">
                            <label htmlFor="alterar-sol-confirmar-senha">Confirmar senha</label>
                            <div className="login-input-wrap">
                                <i className="fas fa-lock login-input-icon" />
                                <input
                                    id="alterar-sol-confirmar-senha"
                                    type={mostrarSenha ? 'text' : 'password'}
                                    value={confirmar}
                                    onChange={(e) => setConfirmar(e.target.value)}
                                    placeholder="Confirmar senha"
                                    autoComplete="new-password"
                                    disabled={carregando}
                                />
                            </div>
                        </div>
                        {mensagemErro && (
                            <div className="login-alert login-alert--error" role="alert">
                                <i className="fas fa-circle-exclamation" /> <strong>{mensagemErro}</strong>
                            </div>
                        )}
                        <button type="submit" className="login-submit" disabled={carregando}>
                            {carregando ? <><span className="sol-spinner" /> Alterando...</> : <><i className="fas fa-check" /> Alterar senha</>}
                        </button>
                    </form>
                    <footer className="login-footer">
                        <div className="login-footer-line">
                            <Link to="/Solicitante/home">Não quero alterar</Link>
                        </div>
                        <div className="login-footer-line">
                            &copy; Desenvolvido por Softbridge · {new Date().getFullYear()}
                        </div>
                    </footer>
                </div>
            </div>
        </div>
    );
}

export default AlterarSenhaSolicitante;
